import { render, staticRenderFns } from "./button.vue?vue&type=template&id=132f13cf&"
import script from "./button.vue?vue&type=script&lang=ts&"
export * from "./button.vue?vue&type=script&lang=ts&"
import style0 from "./button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports